// extracted by mini-css-extract-plugin
module.exports = {"bvpContainer":"_2d60778"};